<section
	class="carousel relative w-full h-[500px] sm:h-[600px] md:h-[700px] lg:h-[800px] mt-[64px] sm:mt-0 md:mt-0 lg:mt-0 overflow-hidden">
	<!-- Carousel Items -->
	<div *ngFor="let slide of slides; let i = index" [ngClass]="{
         'hidden': currentSlide !== i, 
         'block': currentSlide === i, 
         'second-slide': i === 1
       }" class="absolute inset-0 w-full h-full transition-transform duration-1500 ease-in-out"
		[class.translate-x-full]="currentSlide !== i && i > currentSlide"
		[class.-translate-x-full]="currentSlide !== i && i < currentSlide" [class.transform-none]="currentSlide === i">

		<!-- Slide Image -->
		<img [src]="slide.image" [srcset]="slide.srcset"
			sizes="(max-width: 640px) 100vw, (max-width: 1024px) 100vw, (max-width: 1440px) 100vw, 100vw"
			class="w-full h-full object-cover" [attr.loading]="i === 0 ? 'eager' : 'lazy'" [alt]="slide.alt" />
		<!-- Overlay -->
		<div class="overlay absolute inset-0 bg-overlay"></div>

		<!-- Slide Content -->
		<div class="carousel-content absolute inset-0 flex flex-col justify-center text-white px-4" [ngClass]="{
           'text-left items-start pl-4': i === 1, 
           'text-center items-center': i !== 1
         }">
			<div class="mt-8 sm:mt-12 md:mt-16 lg:mt-20 xl:mt-24">
				<h2 class="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-regular mb-2 animate-fadeInUp">
					{{ ('home_carousel.titles.title' + (i + 1)) | translate }}
				</h2>
				<p
					class="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-semibold mb-4 animate-fadeInUp-delay-1">
					{{ ('home_carousel.descriptions.description' + (i + 1)) | translate }}
				</p>
				<p
					class="text-xxs sm:text-xs md:text-sm lg:text-base xl:text-lg font-light mb-10 mt-8 animate-fadeInUp-delay-2">
					{{ ('home_carousel.subdescriptions.subdescription' + (i + 1)) | translate }}
				</p>

				<!-- Buttons for First Slide -->
				<!-- Botones Slide 1 -->
				<div *ngIf="i === 0" class="flex justify-center space-x-4 mt-12 animate-fadeInUp-delay-3">
					<button type="button" (click)="goToAbout()"
						[attr.aria-label]="'home_carousel.button1_aria' | translate" class="button-primary">
						{{ 'home_carousel.button1' | translate }}
					</button>

					<button type="button" (click)="goToContact()"
						[attr.aria-label]="'home_carousel.button2_aria' | translate"
						class="button-secondary w-[110px] h-[40px] sm:w-[134px] sm:h-[45px] py-2 px-4 flex items-center justify-center cursor-pointer">
						{{ 'home_carousel.button2' | translate }}
					</button>
				</div>

				<!-- Botones Slide 2 -->
				<div *ngIf="i === 1"
					class="flex sm:justify-start justify-center space-x-4 mt-16 animate-fadeInUp-delay-3">
					<button type="button" (click)="goToAbout()"
						[attr.aria-label]="'home_carousel.button1_aria' | translate" class="button-primary">
						{{ 'home_carousel.button1' | translate }}
					</button>

					<button type="button" (click)="goToContact()"
						[attr.aria-label]="'home_carousel.button2_aria' | translate"
						class="button-secondary w-[110px] h-[40px] sm:w-[134px] sm:h-[45px] py-2 px-4 flex items-center justify-center cursor-pointer">
						{{ 'home_carousel.button2' | translate }}
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- Carousel Navigation Buttons -->
	<button (click)="previousSlide()" class="carousel-control-prev absolute left-0 top-1/2 transform -translate-y-1/2"
		aria-label="Anterior">
		<i class="fas fa-chevron-left"></i>
	</button>
	<button (click)="nextSlide()" class="carousel-control-next absolute right-0 top-1/2 transform -translate-y-1/2"
		aria-label="Siguiente">
		<i class="fas fa-chevron-right"></i>
	</button>

	<!-- Carousel Indicators -->
	<div class="carousel-indicators absolute bottom-0 left-0 right-0 flex justify-center p-4">
		<div *ngFor="let slide of slides; let i = index"
			class="indicator w-4 h-4 m-1 rounded-full cursor-pointer relative" (click)="goToSlide(i)">
			<div [ngClass]="{
            'indicator-active': currentSlide === i, 
            'indicator-inactive': currentSlide !== i
          }" class="absolute inset-0 rounded-full">
			</div>
		</div>
	</div>
</section>

<!-- "We are a young company specializing in technology" Section -->
<section
	class="flex flex-col md:flex-col lg:flex-row items-center justify-center bg-white py-0 relative max-w-screen-xl mx-auto">
	<!-- image container -->
	<div class="order-2 lg:order-1 w-full lg:w-1/2 h-auto bg-cover lg:h-[480px] xl:w-[542px] xl:h-[480px]">
		<picture>
			<!-- WebP Format -->
			<source [srcset]="'assets/webp/img-04-small.jpg' | imageConverter" type="image/webp"
				media="(max-width: 600px)">
			<source [srcset]="'assets/webp/img-04-medium.jpg' | imageConverter" type="image/webp"
				media="(max-width: 960px)">
			<source [srcset]="'assets/webp/img-04-large.jpg' | imageConverter" type="image/webp"
				media="(max-width: 1200px)">
			<source [srcset]="'assets/webp/img-04-xlarge.jpg' | imageConverter" type="image/webp"
				media="(max-width: 1536px)">

			<!-- Fallback for other formats -->
			<img [srcset]="'assets/img/img-04-small.jpg' | imageConverter" alt="Descripci�n de la imagen"
				class="w-full h-full object-cover" loading="lazy">
		</picture>
	</div>

	<!-- Adjusted text container -->
	<div
		class="order-1 lg:order-2 flex-none w-full lg:w-1/2 h-auto lg:h-[480px] xl:w-[542px] xl:h-[480px] bg-[#CBD6FC] flex items-center justify-center p-6">
		<div
			class="flex flex-col items-center md:items-center lg:items-start text-[#020042] w-full space-y-4 text-center md:text-center lg:text-left md:ml-0 lg:ml-6">
			<img [src]="'assets/svg/about/icono-home-01.svg' | imageConverter" alt="Icono de timon" loading="lazy"
				class="w-[38.15px] h-[43px] mb-4 md:mb-0 mx-auto md:mx-0">

			<h2 class="font-semibold text-[24px] leading-[36px] md:text-[26px] md:leading-[39px]">
				<span class="block w-full text-[24px] md:text-[26px]">{{ 'home_about.title' | translate }}</span>
				<span class="block w-full text-[24px] md:text-[26px]">{{ 'home_about.subtitle' | translate }}</span>
			</h2>

			<div class="w-full md:w-full lg:w-auto max-w-full lg:max-w-[380px] mx-auto md:mx-auto lg:ml-0">
				<p
					class="text-[14px] leading-[21px] md:text-[12px] md:leading-[18px] text-center md:text-center lg:text-left mt-4 w-full md:w-auto max-w-full md:max-w-full lg:max-w-[380px] mx-auto lg:ml-0">
					{{ 'home_about.description' | translate }}
				</p>
			</div>
		</div>
	</div>
</section>
<section class="flex flex-col items-center justify-center bg-white py-0 relative max-w-screen-xl  mx-auto lg:flex-row">

	<!-- First container text -->
	<div
		class="flex-none relative w-full bg-[#CBD6FC] flex items-center justify-center p-6 md:p-14 mb-0 lg:w-1/2 xl:w-[542px]">
		<div class="flex flex-col items-center text-[#020042] w-full space-y-4 h-full justify-center lg:items-start">
			<h2 class="font-semibold text-[12px] font-[Poppins] md:text-[16px] text-center lg:text-left">
				{{ 'home_experience.title' | translate }}
			</h2>
			<p
				class="text-[14px] w-full h-full flex items-center text-[#020042] font-[Poppins] leading-tight text-center mt-4 lg:text-left md:text-[12px] lg:w-auto lg:max-w-[380px] max-w-full">
				{{ 'home_experience.description' | translate }}
			</p>
		</div>
	</div>

	<!-- Image and icons -->
	<div
		class="flex-none relative w-full h-auto md:w-full  xl:w-[542px] md:h-[300px] sm:h-[200px]  lg:w-1/2 lg:h-[197px] xl:h-[197px]">
		<picture>
			<!-- Image for mobile screens -->
			<source srcset="assets/webp/bg-1-home-small.webp" type="image/webp" media="(max-width: 640px)" />

			<!-- Image for tablet screens -->
			<source srcset="assets/webp/bg-1-home-medium.webp" type="image/webp" media="(max-width: 1024px)" />

			<!-- Image for large screens -->
			<source srcset="assets/webp/bg-1-home-large.webp" type="image/webp" media="(min-width: 1025px)" />

			<!-- Fallback PNG -->
			<img src="assets/img/bg-1-home.png" [alt]="'home_icons.alt_background' | translate" loading="lazy"
				class="w-full h-full min-h-[300px] object-cover">
		</picture>

		<div class="absolute inset-0 flex flex-col items-center justify-between h-full lg:flex-row md:flex-col">

			<!-- Innovation -->
			<div
				class="w-full flex-1 flex flex-col items-center justify-center h-full p-2 transition duration-300 ease-in-out group hover:bg-[#F2F4FE]">
				<img src="assets/svg/arq-it/mission.svg" alt="Icono 1" loading="lazy" width="32" height="32"
					class="mb-2 w-8 h-8 transition duration-300 ease-in-out group-hover:filter group-hover:invert object-contain" />
				<p
					class="text-center text-[14px] leading-[21px] md:text-[12px] text-[#F2F4FE] transition duration-300 ease-in-out group-hover:text-[#020042]">
					{{ 'home_icons.values.innovation' | translate }}
				</p>
			</div>

			<!-- Dedication -->
			<div
				class="w-full flex-1 flex flex-col items-center justify-center h-full p-2 transition duration-300 ease-in-out group hover:bg-[#F2F4FE]">
				<img src="assets/svg/arq-it/dedication.svg" alt="Icono 2" loading="lazy" width="32" height="32"
					class="mb-2 w-8 h-8 transition duration-300 ease-in-out group-hover:filter group-hover:invert object-contain" />
				<p
					class="text-center text-[14px] leading-[21px] md:text-[12px] text-[#F2F4FE] transition duration-300 ease-in-out group-hover:text-[#020042]">
					{{ 'home_icons.values.dedication' | translate }}
				</p>
			</div>

			<!-- Permanence -->
			<div
				class="w-full flex-1 flex flex-col items-center justify-center h-full p-2 transition duration-300 ease-in-out group hover:bg-[#F2F4FE]">
				<img src="assets/svg/arq-it/link.svg" alt="Icono 3" loading="lazy" width="32" height="32"
					class="mb-2 w-8 h-8 transition duration-300 ease-in-out group-hover:filter group-hover:invert object-contain" />
				<p
					class="text-center text-[14px] leading-[21px] md:text-[12px] text-[#F2F4FE] transition duration-300 ease-in-out group-hover:text-[#020042]">
					{{ 'home_icons.values.permanence' | translate }}
				</p>
			</div>

		</div>
	</div>
</section>

<!-- Services Section for Mobile Screens -->
<section class="relative w-full bg-[#5173EF] py-16 block md:hidden lg:hidden">
	<div class="max-w-screen-xl mx-auto flex flex-col">
		<!-- Services Content for Mobile -->
		<div class="w-full flex flex-col p-4 bg-[#5173EF] text-[#F2F4FE] xl:pl-5">
			<h2 class="text-[#F2F4FE] text-center text-sm sm:text-base md:text-lg font-semibold mb-4 pl-4">
				{{ 'home_services_mobile.title' | translate }}
			</h2>
			<nav class="flex flex-wrap justify-center gap-2 text-[#F2F4FE] pl-4">
				<a *ngFor="let service of serviceList; trackBy: trackByServiceId" href="#" role="button" tabindex="0"
					[attr.aria-label]="'home_services_mobile.aria.' + service.key | translate"
					class="flex items-center justify-center relative text-[10px] sm:text-[9px] md:text-[9px] lg:text-xs xl:text-[10px] 2xl:text-[11px] font-george-town transition-colors duration-300 hover:text-[#F2F4FE] px-2 py-1 rounded whitespace-nowrap"
					[ngClass]="{
           'text-[#F2F4FE]': selectedService === service.id,
           'bg-white/20': selectedService === service.id
         }" (click)="selectService(service.id, $event)">
					{{ 'home_services_mobile.buttons.' + service.key | translate }}
				</a>
			</nav>
		</div>
	</div>
</section>

<!-- Services Section for Desktop -->
<section class="relative md:block hidden w-full bg-[#5173EF] py-16">
	<div class="max-w-screen-xl mx-auto flex flex-col lg:flex-row">
		<!-- Services Content -->
		<div class="w-full lg:w-1/2 flex flex-col p-4 bg-[#5173EF] text-[#F2F4FE] xl:ml-auto xl:mt-0 xl:pl-5">
			<h2
				class="text-[#F2F4FE] text-center sm:text-left text-sm sm:text-base md:text-lg font-semibold mb-4 pl-4 lg:justify-start xl:pl-4">
				{{ 'home_services_mobile.title' | translate }}
			</h2>
			<nav
				class="flex flex-wrap max-w-screen-xl sm:justify-start gap-2 text-[#F2F4FE] pl-4 xl:justify-start xl:ml-auto xl:gap-1 xl:px-2 lg:flex-row lg:flex-nowrap xl:pl-4">
				<a *ngFor="let service of serviceList; trackBy: trackByServiceId" href="#" role="button" tabindex="0"
					[attr.aria-label]="'home_services_mobile.aria.' + service.key | translate"
					class="flex items-center justify-center relative text-[10px] sm:text-[9px] md:text-[9px] lg:text-xs xl:text-[10px] 2xl:text-[11px] font-george-town transition-colors duration-300 hover:text-[#F2F4FE] px-2 py-1 rounded whitespace-nowrap"
					[ngClass]="{
           'text-[#F2F4FE]': selectedService === service.id,
           'bg-white/20': selectedService === service.id
         }" (click)="selectService(service.id, $event)">
					{{ 'home_services_mobile.buttons.' + service.key | translate }}
				</a>
			</nav>
		</div>
	</div>
</section>

<!-- Service Content Section -->
<section class="relative w-full bg-white mt-0">
	<div class="max-w-screen-xl mx-auto flex flex-col lg:flex-row items-start">
		<!-- Image Section -->
		<div class="w-full lg:w-1/2 xl:mt-[-17.8%] hidden lg:hidden xl:flex xl:w-1/2">
			<img [src]="'assets/img/servicios-home.png' | imageConverter" alt="Servicio" loading="lazy"
				class="w-full h-auto sm:w-[80%] sm:h-auto md:w-[85%] md:h-auto xl:w-[541px] xl:h-[430px] 2xl:w-[541px] 2xl:h-[430px] ml-[11.5%] lg:ml-[0%] xl:ml-[15.5%]">
		</div>

		<!-- Services Content -->
		<div
			class="w-full lg:w-full xl:w-1/2 flex flex-col p-8 pl-8 lg:pl-12 bg-transparent text-[#5173EF] relative group min-h-[150px] sm:min-h-[175px] md:min-h-[200px] lg:min-h-[225px] xl:min-h-[250px] mb-0">
			<h3 class="text-blue-900 text-2xl font-semibold">
				{{ 'home_services_mobile.buttons.' + serviceList[selectedService - 1].key | translate }}
			</h3>
			<hr class="w-20 border-t-2 border-[#020042] mt-3 md:mt-4 lg:mt-5 mb-3">
			<p
				class="text-gray-700 group-hover:text-[#5173EF] transition-colors duration-300 text-xs leading-4 sm:text-xs sm:leading-5 md:text-xs md:leading-6 lg:text-xs lg:leading-7 xl:text-xs xl:leading-7 2xl:text-xs 2xl:leading-6 font-medium italic font-[Poppins] max-w-[90%] lg:max-w-full xl:max-w-[90%]">
				{{ getServiceDescription() }}
			</p>
			<a (click)="goToService()"
				class="absolute right-[10%] md:right-[6%] lg:right-[4%] xl:right-[15%] top-[8%] md:top-[12%] lg:top-[15%] transform translate-x-[100%] opacity-0 group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-500 ease-in-out flex items-center justify-center w-[2.5rem] h-[2.55rem] bg-[#5173EF] text-white rounded-l-[20px] focus:outline-none focus:ring-2 focus:ring-[#020042]"
				role="button" tabindex="0" aria-label="Ver más sobre el servicio">
				<i class="fas fa-arrow-right" aria-hidden="true"></i>
			</a>
		</div>
	</div>
</section>


<!-- CEO & Founder Section -->
<section class="relative flex flex-col items-center justify-center bg-white py-0 max-w-screen-xl mx-auto">
	<div class="w-full max-w-[1080px] mx-auto bg-cover bg-center shadow-lg text-white mt-[-12px] p-4 sm:p-6 lg:p-8 min-h-[240px] sm:min-h-[200px] md:min-h-[240px] lg:min-h-[240px]"
		style="background-image: url('assets/img/bg-ceo-founder.png');">
		<div class="flex flex-col sm:flex-row items-center mb-4 relative mt-4 ml-4 sm:ml-6 md:ml-8 lg:ml-10">
			<!-- Hidden border on mobile -->
			<div
				class="hidden sm:block absolute w-[16%] md:w-[14%] lg:w-[12%] aspect-square border-2 border-[#F2F4FE] sm:-translate-x-3 md:-translate-x-4 -translate-y-2 sm:-translate-y-3 md:-translate-y-4 transform">
			</div>

			<picture>
				<source srcset="{{ 'assets/img/img-ceo.png' | imageConverter }}" type="image/webp">
				<img src="{{ 'assets/img/img-ceo.png' | imageConverter }}" alt="CEO & Founder" loading="lazy"
					class="relative z-10 w-full h-auto max-w-[7.5rem] sm:max-w-[10rem] md:max-w-[12.5rem] lg:max-w-[7.5rem] aspect-square object-cover"
					width="120" height="120" />
			</picture>

			<div class="ml-0 sm:ml-8 md:ml-10 lg:ml-14 mt-4 sm:mt-0 text-center sm:text-left">
				<h3
					class="mb-1 sm:mb-2 md:mb-3 text-[#F2F4FE] font-georgetown font-semibold text-xs sm:text-sm md:text-base lg:text-lg tracking-[0.5px]">
					{{ 'ceo_section.name' | translate }}
				</h3>
				<p
					class="mb-1 sm:mb-2 md:mb-3 font-[Poppins] text-[#CBD6FC] text-[8px] sm:text-[10px] md:text-xs lg:text-sm">
					{{ 'ceo_section.role' | translate }}</p>
				<p
					class="font-light font-[Poppins] text-[8px] sm:text-[10px] md:text-[12px] lg:text-[12px] leading-[1.2] sm:leading-[1.25] md:leading-[1.3] lg:leading-[1.35] max-w-[400px] sm:max-w-[500px] md:max-w-[600px] lg:max-w-[650px] text-[#F2F4FE]">
					{{ 'ceo_section.quote_part1' | translate }} {{ 'ceo_section.quote_part2' | translate }}
				</p>
			</div>
		</div>
	</div>
</section>

<!-- Design for Mobile and MD -->
<section class="flex flex-col md:flex-col lg:hidden xl:hidden 2xl:hidden relative w-full ">
	<div class="relative w-full z-10">

		<picture>
			<source srcset="assets/webp/bg-partners.webp" type="image/webp" />
			<img src="assets/img/bg-partners.png" alt="Imagen de fondo de contactanos" loading="lazy"
				class="w-full h-auto object-cover" width="540" height="680" />
		</picture>

		<!-- Centered text container -->
		<div class="absolute inset-0 flex flex-col justify-center items-center text-white p-4">
			<h3
				class="text-[14px] md:text-[15px] lg:text-[16px] font-[Poppins] font-medium mb-3 md:mb-4 lg:mb-5 text-center">
				{{ 'home_contact_banner.title' | translate }}
			</h3>
			<p
				class="text-[10px] md:text-[11px] lg:text-[12px] font-[Poppins] font-medium mt-2 md:mt-3 lg:mt-4 mb-6 md:mb-7 lg:mb-8 text-center">
				{{ 'home_contact_banner.subtitle' | translate }}
			</p>
			<a href="/contact" role="button" [attr.aria-label]="'home_contact_banner.aria' | translate"
				class="inline-block w-[135px] h-[34px] text-center text-[10px] md:text-[11px] lg:text-[12px] font-[Poppins] bg-[#5173EF] text-[#F2F4FE] py-1.5 px-4 rounded-[4px] transition-all duration-300 hover:bg-[#F2F4FE] hover:border hover:border-[#020042] hover:text-[#020042] focus:outline-none focus:ring-2 focus:ring-[#020042] flex items-center justify-center">
				{{ 'home_contact_banner.cta' | translate }}
			</a>
		</div>
	</div>
</section>

<section class="absolute hidden flex flex-col md:flex-col lg:flex-row lg:w-1/2 right-0 lg:block xl:block 2xl:block">
	<div class="relative w-full z-10
                lg:w-[50vw] lg:max-w-[540px] lg:max-h-[809px] 
                xl:w-[60vw] xl:max-w-[540px] xl:max-h-[680px] 
                2xl:w-[50vw] 2xl:max-w-[540px] 2xl:max-h-[680px]">

		<!-- Background image -->
		<picture>
			<source srcset="assets/img/bg-partners.png" type="image/webp">
			<img src="assets/img/bg-partners.png" class="w-full h-auto object-cover"
				alt="Imagen de fondo de contactanos" loading="lazy" width="540" height="680">
		</picture>
		<!-- Centered text container -->
		<div class="absolute inset-0 flex flex-col justify-center items-center text-white p-4">
			<h3
				class="text-[14px] md:text-[15px] lg:text-[16px] font-[Poppins] font-medium mb-3 md:mb-4 lg:mb-5 text-center">
				{{ 'home_contact_banner.title' | translate }}
			</h3>
			<p
				class="text-[10px] md:text-[11px] lg:text-[12px] font-[Poppins] font-medium mt-2 md:mt-3 lg:mt-4 mb-6 md:mb-7 lg:mb-8 text-center">
				{{ 'home_contact_banner.subtitle' | translate }}
			</p>
			<a href="/contact" role="button" aria-label="Ir a la página de contacto"
				class="inline-block w-[135px] h-[34px] text-center text-[10px] md:text-[11px] lg:text-[12px] font-[Poppins] bg-[#5173EF] text-[#F2F4FE] py-1.5 px-4 rounded-[4px] transition-all duration-300 hover:bg-[#F2F4FE] hover:border hover:border-[#020042] hover:text-[#020042] focus:outline-none focus:ring-2 focus:ring-[#020042] flex items-center justify-center">
				{{ 'home_contact_banner.cta' | translate }}
			</a>
		</div>
	</div>
</section>



<section class="w-full bg-[#5173EF] py-10 z-0">

	<div
		class="space-y-4 md:space-y-5 lg:space-y-6 px-4 sm:px-6 md:px-20 lg:px-12 xl:px-20 max-w-screen-xl mx-auto text-center md:text-left">
		<h2
			class="text-[1.125rem] md:text-[1.375rem] lg:text-[1.625rem] font-normal font-[Poppins] text-[#F2F4FE] mb-0.75 md:mb-0.5 lg:mb-0.25">
			{{ 'home_partners.title' | translate }}
		</h2>
		<hr class="border-t-1 border-[#F2F4FE] w-12 md:w-16 lg:w-20 my-0.75 md:my-0.5 lg:my-0.25 mx-auto md:mx-0">
		<!-- No-break text on mobile -->
		<p
			class="text-[10px] md:text-[11px] lg:text-[12px] leading-[1.75] md:leading-[1.85] lg:leading-[1.95] font-light font-[Poppins] italic text-[#F2F4FE] mt-0.5 md:mt-0.25 lg:mt-0 block md:hidden">
			{{ 'home_partners.description_mobile' | translate }}
		</p>
		<!-- Text with breaks on larger screens -->
		<p class="hidden md:block text-[10px] md:text-[11px] lg:text-[12px] leading-[1.75] md:leading-[1.85] lg:leading-[1.95] font-light font-[Poppins] italic text-[#F2F4FE] mt-0.5 md:mt-0.25 lg:mt-0"
			[innerHTML]="'home_partners.description_desktop' | translate">

		</p>
	</div>

</section>



<section class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 max-w-full">

	<!-- Main Content Box -->
	<div
		class="grid-row gap-0 mx-auto px-4 sm:px-6 lg:px-8 space-y-8  lg:space-y-6 mt-6 sm:mt-6 md:mt-6 lg:mt-10  lg:mb-14 xl:justify-end xl:mr-[4%] 2xl:mr-[2%]  ">

		<!-- AWS Partner -->
		<div class="mb-4 ">
			<div class="flex">
				<div class="bg-[#020042] flex-shrink-0 p-4 w-[155px] h-[106px] flex items-center justify-center">
					<img [src]="'assets/svg/arq-it/aws.svg' | imageConverter" alt="AWS Logo" loading="lazy" width="100"
						height="40" class="w-[70%] h-auto object-contain">
				</div>
				<div class="ml-6 flex-grow flex flex-col justify-center">
					<h3
						class="text-[0.75rem] sm:text-[0.75rem] md:text-[0.875rem] lg:text-[1rem] font-[Poppins] font-medium text-[#020042] mt-0.25 sm:mt-0.5 md:mt-0.75 lg:mt-1">
						{{ 'home_cloud_partners.aws.title' | translate }}
					</h3>
					<p
						class="mt-0.25 text-[0.5rem] sm:text-[0.5rem] md:text-[0.625rem] lg:text-[0.75rem] font-[Poppins] italic text-[#020042] leading-[1.4] sm:leading-[1.5] md:leading-[1.6] lg:leading-[1.7]">
						{{ 'home_cloud_partners.aws.line1_before' | translate }}Í
						<span class="font-bold italic">{{ 'home_cloud_partners.aws.line1_highlight' | translate
							}}</span>
						{{ 'home_cloud_partners.aws.line1_after' | translate }}<br>
						{{ 'home_cloud_partners.aws.line2' | translate }}<br>
						{{ 'home_cloud_partners.aws.line3' | translate }}
					</p>
				</div>
			</div>
			<hr class="border-t-2 border-gray-300 w-[100%]    xl:w-[90%] 2xl:w-[55%] mt-6 ml-0">
		</div>

		<!-- Microsoft Azure Partner -->
		<div class="mb-4">
			<div class="flex items-start">
				<div class="bg-[#020042] flex-shrink-0 p-4 w-[155px] h-[106px] flex items-center justify-center">
					<img [src]="'assets/svg/arq-it/microsoft-azure.svg' | imageConverter" alt="Azure Logo"
						loading="lazy" width="95" height="38" class="w-[65%] h-auto object-contain">
				</div>
				<div class="ml-6 flex-grow flex flex-col justify-center">
					<h3
						class="text-[0.75rem] sm:text-[0.75rem] md:text-[0.875rem] lg:text-[1rem] font-[Poppins] font-medium text-[#020042] mt-0.25 sm:mt-0.5 md:mt-0.5 lg:mt-0.75">
						{{ 'home_cloud_partners.azure.title' | translate }}
					</h3>
					<p
						class="mt-0.25 text-[0.5rem] sm:text-[0.5rem] md:text-[0.625rem] lg:text-[0.75rem] font-[Poppins] italic text-[#020042] leading-[1.4] sm:leading-[1.5] md:leading-[1.6] lg:leading-[1.7]">
						<span [innerHTML]="'home_cloud_partners.azure.line1_start' | translate"></span>
						<br class="hidden sm:block"> {{ 'home_cloud_partners.azure.line2' | translate }}
						<br class="hidden sm:block"> {{ 'home_cloud_partners.azure.line3' | translate }}
					</p>
				</div>
			</div>
			<hr class="border-t-2 border-gray-300 w-[100%] xl:w-[90%] 2xl:w-[55%] mt-6 ml-0">
		</div>

		<!-- Google Cloud Partner -->
		<div class="mb-6">
			<div class="flex items-start">
				<div class="bg-[#020042] flex-shrink-0 p-4 w-[155px] h-[106px] flex items-center justify-center">
					<img [src]="'assets/svg/arq-it/google.svg' | imageConverter" alt="Google Cloud Logo" loading="lazy"
						width="100" height="40" class="w-[70%] h-auto object-contain">
				</div>
				<div class="ml-6 flex-grow flex flex-col justify-center">
					<h3
						class="text-[0.75rem] sm:text-[0.75rem] md:text-[0.875rem] lg:text-[1rem] font-[Poppins] font-medium text-[#020042] mt-0.25 sm:mt-0.5 md:mt-0.5 lg:mt-0.75">
						{{ 'home_cloud_partners.google.title' | translate }}
					</h3>
					<p
						class="mt-0.25 text-[0.5rem] sm:text-[0.5rem] md:text-[0.625rem] lg:text-[0.75rem] font-[Poppins] italic text-[#020042] leading-[1.4] sm:leading-[1.5] md:leading-[1.6] lg:leading-[1.7]">
						{{ 'home_cloud_partners.google.line1' | translate }}
						<br> {{ 'home_cloud_partners.google.line2' | translate }}
						<br> {{ 'home_cloud_partners.google.line3' | translate }}
				</div>
			</div>
			<hr class="border-t-2 border-gray-300 w-[100%]   xl:w-[90%] 2xl:w-[55%] mt-6 ml-0">
		</div>
	</div>
</section>